module.exports = "/assets/12b1059c15d4dd5efd07a706a0d7c2bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VR.png
// module id = 1936
// module chunks = 0